export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'annual-crop-area';
export const REPORT_APE_ID = 'annual-crop-area-ape';
export const SLIDE_NUMBER = 8;